import { render } from "./phone.vue?vue&type=template&id=7e7e8bc8&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import "./phone.vue?vue&type=style&index=0&id=7e7e8bc8&scoped=true&lang=css"

import exportComponent from "/Users/mathieu/conductor/workspaces/miakapp-v3/lima-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7e8bc8"]])

export default __exports__